import React from 'react';
import { Card } from 'react-bootstrap';
import CardBody from '../../../pages/Home/components/CardBody';

export const QuestionTitle: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => <h5 className="card-title">{children}</h5>;

export const QuestionnaireQuestionCard: React.FC<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  return (
    <Card>
      <CardBody>{children}</CardBody>
    </Card>
  );
};
